import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    attribute: { type: String, default: "vehicleId" },
    param: { type: String, default: "vehicle_ids" }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      ghostClass: "opacity-50",
      dragClass: "shadow-2xl",
      handle: "[data-sortable-handle]",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const items = Array.from(this.element.children)
    const ids = items.map(item => item.dataset[this.attributeValue]).filter(Boolean)

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ [this.paramValue]: ids })
      })

      if (!response.ok) {
        console.error("Failed to save order")
        window.location.reload()
      }
    } catch (error) {
      console.error("Error saving order:", error)
      window.location.reload()
    }
  }
}
